import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "filter-bar segment scheme-medium-dark content" }
const _hoisted_2 = { class: "container-content" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-6 col-md-3" }
const _hoisted_5 = { class: "col-6 col-md-9" }
const _hoisted_6 = ["aria-live"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "container-content" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12 col-md-3" }
const _hoisted_11 = ["lang"]
const _hoisted_12 = { class: "small" }
const _hoisted_13 = ["lang"]
const _hoisted_14 = { class: "d-flex" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-spotlight",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_16 = ["lang"]
const _hoisted_17 = { class: "d-flex" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-location",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_19 = ["lang"]
const _hoisted_20 = { class: "d-flex" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-location",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_22 = { class: "col-12 col-md-3 text-md-end" }
const _hoisted_23 = ["href"]
const _hoisted_24 = {
  key: 1,
  class: "segment scheme-light content"
}
const _hoisted_25 = {
  key: 0,
  class: "segment scheme-light content"
}
const _hoisted_26 = { class: "container-content" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "pagination" }

import { inject, Ref, ref } from 'vue';
import PaginationBar from './components/PaginationBar.vue';
import axios, { AxiosResponse } from 'axios';
import {
    handlePopState,
    handlePushState,
    RequestUrl,
    SolrArguments,
    SolrJobDocument,
    SolrResponseData
} from '../modules/solr'; // eslint-disable-line import/no-relative-parent-imports
import SortOptions from './components/SortOptions.vue';
import SearchBar from './components/SearchBar.vue';
import NoResults from './components/NoResults.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'JobsList',
  props: {
    endpoint: {},
    pluginNamespace: {},
    arguments: {}
  },
  setup(__props: any) {

const props = __props;



const i18n = inject('i18n') as { [key: string]: string };
const sortingOptions: { [key: string]: string } = {
    'jobClosingDate ASC': i18n.applicationDeadline, // eslint-disable-line @typescript-eslint/naming-convention
    'jobFirstPublished DESC': i18n.publicationDate // eslint-disable-line @typescript-eslint/naming-convention
};
const defaultArguments: SolrArguments = {
    filter: ['type:tx_fwf_jobs_domain_model_job'],
    page: '1',
    perPage: '8',
    q: '*',
    sort: 'jobClosingDate DESC'
};

const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get('tx_solr[q]') !== null) {
    defaultArguments.q = urlParams.get('tx_solr[q]') as string;
}

const initialArguments: SolrArguments = { ...defaultArguments, ...JSON.parse(props.arguments) as SolrArguments };
const initialUrl = RequestUrl.buildFromArguments(props.endpoint, props.pluginNamespace, initialArguments);
let currentUrl = new RequestUrl(initialUrl);

const listUpdateStatus = ref(false);
const loading = ref(true);

const jobs: Ref<SolrJobDocument[]> = ref([]);
const jobList = ref<HTMLElement|null>(null);

const currentPageNumber = ref(parseInt(initialArguments.page));
const totalNumberOfPages = ref(1);
const currentSorting = ref(initialArguments.sort);
const currentSearchTerm = ref(initialArguments.q);

const spellCheckingSuggestions: Ref<string[]> = ref([]);

function loadJobsAfterPageSelect (page: number): void {
    currentPageNumber.value = page;
    loadJobs();
}

function loadJobsAfterSearchTermGiven (searchTerm: string): void {
    currentSearchTerm.value = searchTerm;
    // Reset page number
    currentPageNumber.value = 1;
    loadJobs();
}

function loadJobsAfterSortingChanged (sorting: string): void {
    currentSorting.value = sorting;
    // Reset page number
    currentPageNumber.value = 1;
    loadJobs();
}

function loadJobs (): void {
    loading.value = true;
    const url = new RequestUrl(currentUrl);

    if (currentSearchTerm.value.trim() === '') {
        currentSearchTerm.value = '*';
    }
    url.setQuery(currentSearchTerm.value);
    url.setSorting(currentSorting.value);
    url.setPage(currentPageNumber.value);

    axios
        .get(url.toString())
        .then((response: AxiosResponse<SolrResponseData>) => {
            jobs.value = response.data.documents as Array<SolrJobDocument>;
            currentPageNumber.value = response.data.currentPage;
            totalNumberOfPages.value = response.data.lastPage;
            spellCheckingSuggestions.value = response.data.spellCheckingSuggestions;

            if (history.state.q !== null && typeof history.state.q === 'string' && history.state.q !== currentSearchTerm.value) { // eslint-disable-line @typescript-eslint/no-unsafe-member-access
                handlePushState(currentSearchTerm.value);
            }

            listUpdateStatus.value = true;
            jobList.value?.focus();

            setTimeout(() => {
                listUpdateStatus.value = false;
            }, 2000);

            return undefined;
        })
        .catch((reason: string) =>
            console.trace('Loading of jobs failed:' + reason)
        )
        .finally(() => {
            loading.value = false;
        });

    currentUrl = url;
}

function formattedClosingDate (job: SolrJobDocument): string {
    const date = new Date(job.jobClosingDate);
    const lang = document.documentElement.lang;

    return (new Intl.DateTimeFormat(lang === 'de' ? 'de-AT' : 'en-US', {
        timeZone: 'UTC'
    })).format(date);
}

function getSchemeByIndex (index: number): string {
    if (index % 2) {
        return 'medium';
    }

    return 'light';
}

const url = new RequestUrl(currentUrl);
axios.get(url.toString())
    .then((response: AxiosResponse<SolrResponseData>) => {
        jobs.value = response.data.documents as Array<SolrJobDocument>;
        currentPageNumber.value = response.data.currentPage;
        totalNumberOfPages.value = response.data.lastPage;
        spellCheckingSuggestions.value = response.data.spellCheckingSuggestions;
        spellCheckingSuggestions.value = response.data.spellCheckingSuggestions;
        handlePushState(currentSearchTerm.value);
        return undefined;
    })
    .catch(() => console.trace('Initial loading of jobs failed.'))
    .finally(() => {
        loading.value = false;
    });

handlePopState(loadJobsAfterSearchTermGiven);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(SortOptions, {
              sorting: defaultArguments.sort,
              "sorting-options": sortingOptions,
              onChange: loadJobsAfterSortingChanged
            }, null, 8 /* PROPS */, ["sorting"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(), _createBlock(SearchBar, {
              key: `search-bar-${currentSearchTerm.value}`,
              "search-term": currentSearchTerm.value,
              onSearch: loadJobsAfterSearchTermGiven
            }, null, 8 /* PROPS */, ["search-term"]))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      ref_key: "jobList",
      ref: jobList,
      class: "job-list",
      "aria-live": listUpdateStatus.value ? 'assertive' : 'off',
      tabindex: "-1"
    }, [
      (jobs.value.length > 0)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobs.value, (job, i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: job.id,
                class: "job-item"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass('segment scheme-' + getSchemeByIndex(i) + ' content')
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("h3", {
                          lang: job.jobLanguageCode
                        }, _toDisplayString(job.title), 9 /* TEXT, PROPS */, _hoisted_11),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(i18n).applicationDeadline) + ": " + _toDisplayString(formattedClosingDate(job)), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", {
                        class: "col-12 col-md-3",
                        lang: job.jobLanguageCode
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          _hoisted_15,
                          _createTextVNode(" " + _toDisplayString(job.jobExpertise), 1 /* TEXT */)
                        ])
                      ], 8 /* PROPS */, _hoisted_13),
                      (job.jobTypeId === 1)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "col-12 col-md-3",
                            lang: job.jobLanguageCode
                          }, [
                            _createElementVNode("div", _hoisted_17, [
                              _hoisted_18,
                              _createTextVNode(" " + _toDisplayString(job.jobWorkplace), 1 /* TEXT */)
                            ])
                          ], 8 /* PROPS */, _hoisted_16))
                        : _createCommentVNode("v-if", true),
                      (job.jobTypeId === 2)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "col-12 col-md-3",
                            lang: job.jobLanguageCode
                          }, [
                            _createElementVNode("div", _hoisted_20, [
                              _hoisted_21,
                              _createTextVNode(" " + _toDisplayString(job.jobHours), 1 /* TEXT */)
                            ])
                          ], 8 /* PROPS */, _hoisted_19))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("a", {
                          href: job.url,
                          class: "button button-cta"
                        }, _toDisplayString(_unref(i18n).discoverMore), 9 /* TEXT, PROPS */, _hoisted_23)
                      ])
                    ])
                  ])
                ], 2 /* CLASS */)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : (!loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createVNode(NoResults, {
                "spell-checking-suggestions": spellCheckingSuggestions.value,
                onSearch: loadJobsAfterSearchTermGiven
              }, null, 8 /* PROPS */, ["spell-checking-suggestions"])
            ]))
          : _createCommentVNode("v-if", true)
    ], 8 /* PROPS */, _hoisted_6),
    (totalNumberOfPages.value > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createVNode(PaginationBar, {
                  current: currentPageNumber.value,
                  total: totalNumberOfPages.value,
                  onSelect: loadJobsAfterPageSelect
                }, null, 8 /* PROPS */, ["current", "total"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})